import { render, staticRenderFns } from "./add-exam-modal.vue?vue&type=template&id=03fbaf8f"
import script from "./add-exam-modal.vue?vue&type=script&lang=ts"
export * from "./add-exam-modal.vue?vue&type=script&lang=ts"
import style0 from "./add-exam-modal.vue?vue&type=style&index=0&id=03fbaf8f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports